module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("页面切换显示loading")]), _vm._v(" "), _c('p', [_vm._v("移动端如果使用异步组件加载那么还是需要一点等待时间的，在网络慢时等待时间会更长。显示"), _c('code', [_vm._v("Loading")]), _vm._v("状态缓解一下用户等待情绪就十分重要。")]), _vm._v(" "), _c('p', [_vm._v("如果你使用"), _c('code', [_vm._v("vue-router")]), _vm._v("和"), _c('code', [_vm._v("vuex")]), _vm._v("，那么可以很容易实现。")]), _vm._v(" "), _c('p', [_vm._v("首先，注册一个"), _c('code', [_vm._v("module")]), _vm._v("来保存状态")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" store = "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("new")]), _vm._v(" Vuex.Store({}) "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 这里你可能已经有其他 module")]), _vm._v("\n\nstore.registerModule("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v(", { "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 名字自己定义")]), _vm._v("\n  state: {\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("isLoading")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("false")]), _vm._v("\n  },\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("mutations")]), _vm._v(": {\n    updateLoadingStatus (state, payload) {\n      state.isLoading = payload.isLoading\n    }\n  }\n})\n")])]), _vm._v(" "), _c('p', [_vm._v("然后使用"), _c('code', [_vm._v("vue-router")]), _vm._v("的"), _c('code', [_vm._v("beforeEach")]), _vm._v("和"), _c('code', [_vm._v("afterEach")]), _vm._v("来更改"), _c('code', [_vm._v("loading")]), _vm._v("状态")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("router.beforeEach("), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("function")]), _vm._v(" ("), _c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("to, from, next")]), _vm._v(") ")]), _vm._v("{\n  store.commit("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'updateLoadingStatus'")]), _vm._v(", {"), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("isLoading")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("true")]), _vm._v("})\n  next()\n})\n\nrouter.afterEach("), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("function")]), _vm._v(" ("), _c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("to")]), _vm._v(") ")]), _vm._v("{\n  store.commit("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'updateLoadingStatus'")]), _vm._v(", {"), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("isLoading")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("false")]), _vm._v("})\n})\n")])]), _vm._v(" "), _c('p', [_vm._v("在"), _c('code', [_vm._v("App.vue")]), _vm._v("里使用"), _c('code', [_vm._v("loading")]), _vm._v("组件并从"), _c('code', [_vm._v("vuex")]), _vm._v("获取"), _c('code', [_vm._v("isLoading")]), _vm._v("状态")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("loading")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("v-model")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"isLoading\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("loading")]), _vm._v(">")]), _vm._v("\n")])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Loading } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { mapState } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vuex'")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("default")]), _vm._v(" {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("components")]), _vm._v(": {\n    Loading\n  },\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("computed")]), _vm._v(": {\n    ...mapState({\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("isLoading")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("state")]), _vm._v(" =>")]), _vm._v(" state.vux.isLoading\n    })\n  }\n}\n")])]), _vm._v(" "), _c('p', [_vm._v("done.")]), _vm._v(" "), _c('p', [_vm._v("如果你觉得在加载比较快时"), _c('code', [_vm._v("Loading")]), _vm._v("组件一闪而过体验也不大好，那么你可以延迟设置"), _c('code', [_vm._v("loading=false")]), _vm._v("。")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-06b99158", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-06b99158"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/vue-show-loading-291.vue
// module id = 2012
// module chunks = 208